module.exports = {
      id: "ic-zoomin-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-zoomin-usage",
      toString: function () {
        return this.url;
      }
    }